/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na DHTMLX Scheduler události s informacemi v iCalendar formátu
 */
class DhtmlxToIcalEventFactory {
  /**
   * @param {Class.<DhtmlxToIcalEvent>} DhtmlxToIcalEvent
   * @param {IcalApi} ICAL
   * @param {DhtmlxDateParser} dateParser
   */
  constructor(DhtmlxToIcalEvent, ICAL, dateParser) {
    this.DhtmlxToIcalEvent = DhtmlxToIcalEvent;
    this.ICAL = ICAL;
    this.dateParser = dateParser;
  }

  /**
   * @param {string} dateFormat Formát datumů v DHTML události
   * @param {DhtmlxEvent} event DHTMLX událost
   * @returns {DhtmlxToIcalEvent}
   */
  create(dateFormat, event) {
    return new this.DhtmlxToIcalEvent(
      this.ICAL,
      dateFormat,
      this.dateParser,
      event
    );
  }
}

export default DhtmlxToIcalEventFactory;
